import { render, staticRenderFns } from "./PVBankAccountEdit.vue?vue&type=template&id=6ed864cd&scoped=true&lang=pug"
import script from "./PVBankAccountEdit.vue?vue&type=script&lang=js"
export * from "./PVBankAccountEdit.vue?vue&type=script&lang=js"
import style0 from "./PVBankAccountEdit.vue?vue&type=style&index=0&id=6ed864cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed864cd",
  null
  
)

export default component.exports